// Apartment Bookings Timeline Dataset
// A couple of months of data with events between one day and two weeks long
// Resources are the various apartments
// Some apartments have mostly short stays (1-3 days), others have longer stays (5-14 days)

// Timeline starts July 1, 2025
export const defaultVisibleDate = new Date('2025-07-01T00:00:00');

export const resources = [
  { title: 'Ocean View Suite', id: 'ocean-suite', eventColor: 'blue' },
  { title: 'Mountain Chalet', id: 'mountain-chalet', eventColor: 'teal' },
  { title: 'City Loft', id: 'city-loft', eventColor: 'purple' },
  { title: 'Garden Studio', id: 'garden-studio', eventColor: 'lime' },
  { title: 'Penthouse', id: 'penthouse', eventColor: 'orange' },
  { title: 'Beach House', id: 'beach-house', eventColor: 'green' },
  { title: 'Lakeside Cabin', id: 'lakeside-cabin', eventColor: 'indigo' },
  { title: 'Downtown Apartment', id: 'downtown-apt', eventColor: 'pink' },
  { title: 'Riverside Villa', id: 'riverside-villa', eventColor: 'grey' },
  { title: 'Hillside Retreat', id: 'hillside-retreat', eventColor: 'red' },
];

export const initialEvents = [
  // ============================================
  // OCEAN VIEW SUITE - Long stays (7-14 days) - vacation property
  // ============================================
  {
    id: 'ocean-1',
    start: '2025-07-01T00:00:00',
    end: '2025-07-11T00:00:00',
    title: 'Smith Family',
    resource: 'ocean-suite',
    allDay: true,
  },
  {
    id: 'ocean-2',
    start: '2025-07-11T00:00:00',
    end: '2025-07-22T00:00:00',
    title: 'Johnson Group',
    resource: 'ocean-suite',
    allDay: true,
  },
  {
    id: 'ocean-3',
    start: '2025-07-26T00:00:00',
    end: '2025-08-05T00:00:00',
    title: 'Williams Party',
    resource: 'ocean-suite',
    allDay: true,
  },
  {
    id: 'ocean-4',
    start: '2025-08-08T00:00:00',
    end: '2025-08-22T00:00:00',
    title: 'Brown Family',
    resource: 'ocean-suite',
    allDay: true,
  },
  {
    id: 'ocean-5',
    start: '2025-08-25T00:00:00',
    end: '2025-09-01T00:00:00',
    title: 'Jones Couple',
    resource: 'ocean-suite',
    allDay: true,
  },
  {
    id: 'ocean-6',
    start: '2025-09-04T00:00:00',
    end: '2025-09-15T00:00:00',
    title: 'Garcia Family',
    resource: 'ocean-suite',
    allDay: true,
  },
  {
    id: 'ocean-7',
    start: '2025-09-19T00:00:00',
    end: '2025-09-29T00:00:00',
    title: 'Miller Party',
    resource: 'ocean-suite',
    allDay: true,
  },
  // ============================================
  // MOUNTAIN CHALET - Long stays (7-14 days) - vacation property
  // ============================================
  {
    id: 'mountain-1',
    start: '2025-07-01T00:00:00',
    end: '2025-07-15T00:00:00',
    title: 'Davis Group',
    resource: 'mountain-chalet',
    allDay: true,
  },
  {
    id: 'mountain-2',
    start: '2025-07-15T00:00:00',
    end: '2025-07-22T00:00:00',
    title: 'Rodriguez Family',
    resource: 'mountain-chalet',
    allDay: true,
  },
  {
    id: 'mountain-3',
    start: '2025-07-26T00:00:00',
    end: '2025-08-07T00:00:00',
    title: 'Martinez Couple',
    resource: 'mountain-chalet',
    allDay: true,
  },
  {
    id: 'mountain-4',
    start: '2025-08-10T00:00:00',
    end: '2025-08-20T00:00:00',
    title: 'Hernandez Family',
    resource: 'mountain-chalet',
    allDay: true,
  },
  {
    id: 'mountain-5',
    start: '2025-08-23T00:00:00',
    end: '2025-09-06T00:00:00',
    title: 'Lopez Party',
    resource: 'mountain-chalet',
    allDay: true,
  },
  {
    id: 'mountain-6',
    start: '2025-09-09T00:00:00',
    end: '2025-09-16T00:00:00',
    title: 'Gonzalez Group',
    resource: 'mountain-chalet',
    allDay: true,
  },
  {
    id: 'mountain-7',
    start: '2025-09-19T00:00:00',
    end: '2025-10-01T00:00:00',
    title: 'Wilson Family',
    resource: 'mountain-chalet',
    allDay: true,
  },
  // ============================================
  // CITY LOFT - Short stays (1-3 days) - business/urban property
  // ============================================
  {
    id: 'loft-1',
    start: '2025-07-01T00:00:00',
    end: '2025-07-03T00:00:00',
    title: 'Anderson Couple',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-2',
    start: '2025-07-03T00:00:00',
    end: '2025-07-05T00:00:00',
    title: 'Thomas Party',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-3',
    start: '2025-07-05T00:00:00',
    end: '2025-07-06T00:00:00',
    title: 'Taylor Family',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-4',
    start: '2025-07-08T00:00:00',
    end: '2025-07-10T00:00:00',
    title: 'Moore Group',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-5',
    start: '2025-07-11T00:00:00',
    end: '2025-07-14T00:00:00',
    title: 'Jackson Family',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-6',
    start: '2025-07-15T00:00:00',
    end: '2025-07-17T00:00:00',
    title: 'Martin Couple',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-7',
    start: '2025-07-19T00:00:00',
    end: '2025-07-21T00:00:00',
    title: 'Lee Family',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-8',
    start: '2025-07-22T00:00:00',
    end: '2025-07-23T00:00:00',
    title: 'Perez Party',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-9',
    start: '2025-07-25T00:00:00',
    end: '2025-07-28T00:00:00',
    title: 'Thompson Group',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-10',
    start: '2025-07-29T00:00:00',
    end: '2025-07-31T00:00:00',
    title: 'White Family',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-11',
    start: '2025-08-02T00:00:00',
    end: '2025-08-04T00:00:00',
    title: 'Harris Couple',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-12',
    start: '2025-08-05T00:00:00',
    end: '2025-08-06T00:00:00',
    title: 'Sanchez Family',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-13',
    start: '2025-08-08T00:00:00',
    end: '2025-08-11T00:00:00',
    title: 'Clark Party',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-14',
    start: '2025-08-13T00:00:00',
    end: '2025-08-15T00:00:00',
    title: 'Ramirez Group',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-15',
    start: '2025-08-17T00:00:00',
    end: '2025-08-19T00:00:00',
    title: 'Lewis Family',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-16',
    start: '2025-08-20T00:00:00',
    end: '2025-08-22T00:00:00',
    title: 'Robinson Couple',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-17',
    start: '2025-08-25T00:00:00',
    end: '2025-08-27T00:00:00',
    title: 'Walker Family',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-18',
    start: '2025-08-28T00:00:00',
    end: '2025-08-29T00:00:00',
    title: 'Young Party',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-19',
    start: '2025-09-01T00:00:00',
    end: '2025-09-04T00:00:00',
    title: 'Allen Group',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-20',
    start: '2025-09-07T00:00:00',
    end: '2025-09-09T00:00:00',
    title: 'King Family',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-21',
    start: '2025-09-11T00:00:00',
    end: '2025-09-13T00:00:00',
    title: 'Wright Couple',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-22',
    start: '2025-09-15T00:00:00',
    end: '2025-09-17T00:00:00',
    title: 'Scott Family',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-23',
    start: '2025-09-19T00:00:00',
    end: '2025-09-21T00:00:00',
    title: 'Torres Party',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-24',
    start: '2025-09-23T00:00:00',
    end: '2025-09-25T00:00:00',
    title: 'Nguyen Group',
    resource: 'city-loft',
    allDay: true,
  },
  {
    id: 'loft-25',
    start: '2025-09-27T00:00:00',
    end: '2025-09-29T00:00:00',
    title: 'Hill Family',
    resource: 'city-loft',
    allDay: true,
  },
  // ============================================
  // GARDEN STUDIO - Short stays (1-3 days) - urban property
  // ============================================
  {
    id: 'garden-1',
    start: '2025-07-01T00:00:00',
    end: '2025-07-02T00:00:00',
    title: 'Flores Couple',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-2',
    start: '2025-07-03T00:00:00',
    end: '2025-07-06T00:00:00',
    title: 'Green Family',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-3',
    start: '2025-07-07T00:00:00',
    end: '2025-07-09T00:00:00',
    title: 'Adams Party',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-4',
    start: '2025-07-10T00:00:00',
    end: '2025-07-12T00:00:00',
    title: 'Nelson Group',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-5',
    start: '2025-07-13T00:00:00',
    end: '2025-07-15T00:00:00',
    title: 'Baker Family',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-6',
    start: '2025-07-16T00:00:00',
    end: '2025-07-18T00:00:00',
    title: 'Hall Couple',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-7',
    start: '2025-07-20T00:00:00',
    end: '2025-07-22T00:00:00',
    title: 'Rivera Family',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-8',
    start: '2025-07-23T00:00:00',
    end: '2025-07-24T00:00:00',
    title: 'Campbell Party',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-9',
    start: '2025-07-26T00:00:00',
    end: '2025-07-29T00:00:00',
    title: 'Mitchell Group',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-10',
    start: '2025-07-31T00:00:00',
    end: '2025-08-02T00:00:00',
    title: 'Carter Family',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-11',
    start: '2025-08-03T00:00:00',
    end: '2025-08-05T00:00:00',
    title: 'Roberts Couple',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-12',
    start: '2025-08-07T00:00:00',
    end: '2025-08-09T00:00:00',
    title: 'Phillips Family',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-13',
    start: '2025-08-10T00:00:00',
    end: '2025-08-12T00:00:00',
    title: 'Evans Party',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-14',
    start: '2025-08-14T00:00:00',
    end: '2025-08-16T00:00:00',
    title: 'Turner Group',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-15',
    start: '2025-08-18T00:00:00',
    end: '2025-08-20T00:00:00',
    title: 'Diaz Family',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-16',
    start: '2025-08-22T00:00:00',
    end: '2025-08-24T00:00:00',
    title: 'Parker Couple',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-17',
    start: '2025-08-26T00:00:00',
    end: '2025-08-28T00:00:00',
    title: 'Cruz Family',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-18',
    start: '2025-08-30T00:00:00',
    end: '2025-09-01T00:00:00',
    title: 'Edwards Party',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-19',
    start: '2025-09-04T00:00:00',
    end: '2025-09-06T00:00:00',
    title: 'Collins Group',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-20',
    start: '2025-09-09T00:00:00',
    end: '2025-09-11T00:00:00',
    title: 'Reyes Family',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-21',
    start: '2025-09-14T00:00:00',
    end: '2025-09-16T00:00:00',
    title: 'Stewart Couple',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-22',
    start: '2025-09-19T00:00:00',
    end: '2025-09-21T00:00:00',
    title: 'Morris Party',
    resource: 'garden-studio',
    allDay: true,
  },
  {
    id: 'garden-23',
    start: '2025-09-24T00:00:00',
    end: '2025-09-26T00:00:00',
    title: 'Morales Group',
    resource: 'garden-studio',
    allDay: true,
  },
  // ============================================
  // PENTHOUSE - Long stays (7-14 days) - luxury vacation property
  // ============================================
  {
    id: 'pent-1',
    start: '2025-07-01T00:00:00',
    end: '2025-07-13T00:00:00',
    title: 'Murphy Family',
    resource: 'penthouse',
    allDay: true,
  },
  {
    id: 'pent-2',
    start: '2025-07-16T00:00:00',
    end: '2025-07-26T00:00:00',
    title: 'Cook Couple',
    resource: 'penthouse',
    allDay: true,
  },
  {
    id: 'pent-3',
    start: '2025-07-29T00:00:00',
    end: '2025-08-10T00:00:00',
    title: 'Rogers Party',
    resource: 'penthouse',
    allDay: true,
  },
  {
    id: 'pent-4',
    start: '2025-08-13T00:00:00',
    end: '2025-08-25T00:00:00',
    title: 'Gutierrez Group',
    resource: 'penthouse',
    allDay: true,
  },
  {
    id: 'pent-5',
    start: '2025-08-28T00:00:00',
    end: '2025-09-04T00:00:00',
    title: 'Ortiz Family',
    resource: 'penthouse',
    allDay: true,
  },
  {
    id: 'pent-6',
    start: '2025-09-09T00:00:00',
    end: '2025-09-21T00:00:00',
    title: 'Morgan Couple',
    resource: 'penthouse',
    allDay: true,
  },
  {
    id: 'pent-7',
    start: '2025-09-24T00:00:00',
    end: '2025-10-01T00:00:00',
    title: 'Cooper Party',
    resource: 'penthouse',
    allDay: true,
  },
  // ============================================
  // BEACH HOUSE - Long stays (7-14 days) - vacation property
  // ============================================
  {
    id: 'beach-1',
    start: '2025-07-01T00:00:00',
    end: '2025-07-15T00:00:00',
    title: 'Peterson Group',
    resource: 'beach-house',
    allDay: true,
  },
  {
    id: 'beach-2',
    start: '2025-07-15T00:00:00',
    end: '2025-07-22T00:00:00',
    title: 'Bailey Family',
    resource: 'beach-house',
    allDay: true,
  },
  {
    id: 'beach-3',
    start: '2025-07-25T00:00:00',
    end: '2025-08-05T00:00:00',
    title: 'Reed Couple',
    resource: 'beach-house',
    allDay: true,
  },
  {
    id: 'beach-4',
    start: '2025-08-08T00:00:00',
    end: '2025-08-20T00:00:00',
    title: 'Kelly Party',
    resource: 'beach-house',
    allDay: true,
  },
  {
    id: 'beach-5',
    start: '2025-08-23T00:00:00',
    end: '2025-08-30T00:00:00',
    title: 'Howard Group',
    resource: 'beach-house',
    allDay: true,
  },
  {
    id: 'beach-6',
    start: '2025-09-02T00:00:00',
    end: '2025-09-16T00:00:00',
    title: 'Ramos Family',
    resource: 'beach-house',
    allDay: true,
  },
  {
    id: 'beach-7',
    start: '2025-09-19T00:00:00',
    end: '2025-09-29T00:00:00',
    title: 'Kim Couple',
    resource: 'beach-house',
    allDay: true,
  },
  // ============================================
  // LAKESIDE CABIN - Long stays (7-14 days) - vacation property
  // ============================================
  {
    id: 'lake-1',
    start: '2025-07-01T00:00:00',
    end: '2025-07-11T00:00:00',
    title: 'Cox Party',
    resource: 'lakeside-cabin',
    allDay: true,
  },
  {
    id: 'lake-2',
    start: '2025-07-13T00:00:00',
    end: '2025-07-27T00:00:00',
    title: 'Ward Group',
    resource: 'lakeside-cabin',
    allDay: true,
  },
  {
    id: 'lake-3',
    start: '2025-07-30T00:00:00',
    end: '2025-08-06T00:00:00',
    title: 'Richardson Family',
    resource: 'lakeside-cabin',
    allDay: true,
  },
  {
    id: 'lake-4',
    start: '2025-08-10T00:00:00',
    end: '2025-08-22T00:00:00',
    title: 'Watson Couple',
    resource: 'lakeside-cabin',
    allDay: true,
  },
  {
    id: 'lake-5',
    start: '2025-08-25T00:00:00',
    end: '2025-09-04T00:00:00',
    title: 'Brooks Party',
    resource: 'lakeside-cabin',
    allDay: true,
  },
  {
    id: 'lake-6',
    start: '2025-09-07T00:00:00',
    end: '2025-09-17T00:00:00',
    title: 'Chavez Group',
    resource: 'lakeside-cabin',
    allDay: true,
  },
  {
    id: 'lake-7',
    start: '2025-09-20T00:00:00',
    end: '2025-10-01T00:00:00',
    title: 'Wood Family',
    resource: 'lakeside-cabin',
    allDay: true,
  },
  // ============================================
  // DOWNTOWN APARTMENT - Short stays (1-3 days) - business property
  // ============================================
  {
    id: 'downtown-1',
    start: '2025-07-01T00:00:00',
    end: '2025-07-03T00:00:00',
    title: 'James Couple',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-2',
    start: '2025-07-03T00:00:00',
    end: '2025-07-05T00:00:00',
    title: 'Bennett Party',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-3',
    start: '2025-07-06T00:00:00',
    end: '2025-07-08T00:00:00',
    title: 'Gray Group',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-4',
    start: '2025-07-09T00:00:00',
    end: '2025-07-11T00:00:00',
    title: 'Mendoza Family',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-5',
    start: '2025-07-12T00:00:00',
    end: '2025-07-14T00:00:00',
    title: 'Ruiz Couple',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-6',
    start: '2025-07-16T00:00:00',
    end: '2025-07-18T00:00:00',
    title: 'Hughes Party',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-7',
    start: '2025-07-19T00:00:00',
    end: '2025-07-20T00:00:00',
    title: 'Price Group',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-8',
    start: '2025-07-22T00:00:00',
    end: '2025-07-25T00:00:00',
    title: 'Alvarez Family',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-9',
    start: '2025-07-26T00:00:00',
    end: '2025-07-28T00:00:00',
    title: 'Castillo Couple',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-10',
    start: '2025-07-29T00:00:00',
    end: '2025-07-31T00:00:00',
    title: 'Sanders Party',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-11',
    start: '2025-08-02T00:00:00',
    end: '2025-08-04T00:00:00',
    title: 'Patel Group',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-12',
    start: '2025-08-05T00:00:00',
    end: '2025-08-07T00:00:00',
    title: 'Myers Family',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-13',
    start: '2025-08-08T00:00:00',
    end: '2025-08-10T00:00:00',
    title: 'Long Couple',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-14',
    start: '2025-08-12T00:00:00',
    end: '2025-08-14T00:00:00',
    title: 'Foster Party',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-15',
    start: '2025-08-15T00:00:00',
    end: '2025-08-16T00:00:00',
    title: 'Jimenez Group',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-16',
    start: '2025-08-18T00:00:00',
    end: '2025-08-21T00:00:00',
    title: 'Powell Family',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-17',
    start: '2025-08-23T00:00:00',
    end: '2025-08-25T00:00:00',
    title: 'Jenkins Couple',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-18',
    start: '2025-08-27T00:00:00',
    end: '2025-08-29T00:00:00',
    title: 'Perry Party',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-19',
    start: '2025-08-31T00:00:00',
    end: '2025-09-02T00:00:00',
    title: 'Russell Group',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-20',
    start: '2025-09-04T00:00:00',
    end: '2025-09-06T00:00:00',
    title: 'Sullivan Family',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-21',
    start: '2025-09-08T00:00:00',
    end: '2025-09-10T00:00:00',
    title: 'Bell Couple',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-22',
    start: '2025-09-12T00:00:00',
    end: '2025-09-14T00:00:00',
    title: 'Coleman Party',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-23',
    start: '2025-09-17T00:00:00',
    end: '2025-09-19T00:00:00',
    title: 'Butler Group',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-24',
    start: '2025-09-21T00:00:00',
    end: '2025-09-23T00:00:00',
    title: 'Barnes Family',
    resource: 'downtown-apt',
    allDay: true,
  },
  {
    id: 'downtown-25',
    start: '2025-09-25T00:00:00',
    end: '2025-09-27T00:00:00',
    title: 'Fisher Couple',
    resource: 'downtown-apt',
    allDay: true,
  },
  // ============================================
  // RIVERSIDE VILLA - Long stays (7-14 days) - vacation property
  // ============================================
  {
    id: 'river-1',
    start: '2025-07-01T00:00:00',
    end: '2025-07-10T00:00:00',
    title: 'Henderson Party',
    resource: 'riverside-villa',
    allDay: true,
  },
  {
    id: 'river-2',
    start: '2025-07-13T00:00:00',
    end: '2025-07-26T00:00:00',
    title: 'Wallace Group',
    resource: 'riverside-villa',
    allDay: true,
  },
  {
    id: 'river-3',
    start: '2025-07-29T00:00:00',
    end: '2025-08-08T00:00:00',
    title: 'Woods Family',
    resource: 'riverside-villa',
    allDay: true,
  },
  {
    id: 'river-4',
    start: '2025-08-12T00:00:00',
    end: '2025-08-22T00:00:00',
    title: 'Mason Couple',
    resource: 'riverside-villa',
    allDay: true,
  },
  {
    id: 'river-5',
    start: '2025-08-25T00:00:00',
    end: '2025-09-06T00:00:00',
    title: 'Dixon Party',
    resource: 'riverside-villa',
    allDay: true,
  },
  {
    id: 'river-6',
    start: '2025-09-09T00:00:00',
    end: '2025-09-19T00:00:00',
    title: 'Hunt Group',
    resource: 'riverside-villa',
    allDay: true,
  },
  {
    id: 'river-7',
    start: '2025-09-22T00:00:00',
    end: '2025-10-01T00:00:00',
    title: 'Palmer Family',
    resource: 'riverside-villa',
    allDay: true,
  },
  // ============================================
  // HILLSIDE RETREAT - Long stays (7-14 days) - vacation property
  // ============================================
  {
    id: 'hill-1',
    start: '2025-07-01T00:00:00',
    end: '2025-07-12T00:00:00',
    title: 'Grant Couple',
    resource: 'hillside-retreat',
    allDay: true,
  },
  {
    id: 'hill-2',
    start: '2025-07-15T00:00:00',
    end: '2025-07-29T00:00:00',
    title: 'Stone Party',
    resource: 'hillside-retreat',
    allDay: true,
  },
  {
    id: 'hill-3',
    start: '2025-08-01T00:00:00',
    end: '2025-08-08T00:00:00',
    title: 'Webb Group',
    resource: 'hillside-retreat',
    allDay: true,
  },
  {
    id: 'hill-4',
    start: '2025-08-12T00:00:00',
    end: '2025-08-25T00:00:00',
    title: 'Ford Family',
    resource: 'hillside-retreat',
    allDay: true,
  },
  {
    id: 'hill-5',
    start: '2025-08-28T00:00:00',
    end: '2025-09-07T00:00:00',
    title: 'Hayes Couple',
    resource: 'hillside-retreat',
    allDay: true,
  },
  {
    id: 'hill-6',
    start: '2025-09-11T00:00:00',
    end: '2025-09-24T00:00:00',
    title: 'Warren Party',
    resource: 'hillside-retreat',
    allDay: true,
  },
  {
    id: 'hill-7',
    start: '2025-09-27T00:00:00',
    end: '2025-10-04T00:00:00',
    title: 'Dunn Group',
    resource: 'hillside-retreat',
    allDay: true,
  },
];
